var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view order-detail" },
    [
      [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isEdit,
                  expression: "isEdit"
                }
              ],
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-left": "0px" }
            },
            [
              _c(
                "div",
                { staticClass: "triggers" },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.doSave } },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Save")))]
                  ),
                  _c("el-button", { on: { click: _vm.cancel } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
                  ]),
                  false
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "warning" },
                          on: { click: _vm.preQuotation }
                        },
                        [_vm._v(_vm._s(_vm.$t("FbaChannel.previewQuotation")))]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isEdit,
                  expression: "!isEdit"
                }
              ],
              staticClass: "app-main-inner-row",
              staticStyle: {
                "padding-left": "0px",
                "justify-content": "space-between"
              }
            },
            [
              _c(
                "div",
                { staticClass: "triggers" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.toBackList }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Return")))]
                  ),
                  _vm.$checkPermission(["button_FBAQuotation_editQuotation"])
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", disabled: !_vm.form.uuid },
                          on: { click: _vm.toEdit }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "section quotation-detail",
              staticStyle: {
                "margin-top": "5px",
                width: "100%",
                height: "95%",
                overflow: "auto"
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    "label-width": "110px",
                    "label-position": "left",
                    disabled: !_vm.isEdit,
                    "show-message": false
                  }
                },
                [
                  _c(
                    "el-collapse",
                    {
                      attrs: { value: _vm.collapse },
                      on: { change: _vm.handleChange }
                    },
                    [
                      _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title: _vm.$t("SeaExport.BasicInfo"),
                            name: 1
                          }
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  !_vm.isAdd
                                    ? _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "blue",
                                              attrs: { slot: "label" },
                                              slot: "label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FbaChannel.channelName"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c("cargo-advance-select", {
                                            attrs: {
                                              no: "serviceChannel",
                                              disabled: "",
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .basic_data_FbaChannel,
                                              filterable: "",
                                              clearable: true,
                                              "default-value":
                                                _vm.form.serviceChannel
                                            },
                                            on: {
                                              parentCallBack: function(p) {
                                                _vm.form.serviceChannel =
                                                  p.value
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.isAdd
                                    ? _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "blue",
                                              attrs: { slot: "label" },
                                              slot: "label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FbaChannel.channelName"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-select",
                                            {
                                              attrs: { filterable: "" },
                                              on: {
                                                change: _vm.changeChannelName
                                              },
                                              model: {
                                                value: _vm.form.serviceChannel,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "serviceChannel",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.serviceChannel"
                                              }
                                            },
                                            _vm._l(
                                              _vm.channel4QuotationSelect,
                                              function(item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.channelName,
                                                    value: item.channelName
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "blue",
                                          attrs: { slot: "label" },
                                          slot: "label"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "FbaChannel.quotationValidityPeriod"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c("el-date-picker", {
                                        staticStyle: { width: "130px" },
                                        attrs: {
                                          disabled: _vm.form.active,
                                          clearable: false,
                                          "picker-options": _vm.pickerOptions,
                                          type: "date",
                                          "value-format": "yyyy-MM-dd"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.changeDate(false)
                                          }
                                        },
                                        model: {
                                          value: _vm.beginDate,
                                          callback: function($$v) {
                                            _vm.beginDate = $$v
                                          },
                                          expression: "beginDate"
                                        }
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("CargoMsg.Cargo_To")) +
                                          " "
                                      ),
                                      _c("el-date-picker", {
                                        staticStyle: { width: "130px" },
                                        attrs: {
                                          disabled: _vm.form.active,
                                          clearable: false,
                                          "picker-options": _vm.pickerOptions,
                                          type: "date",
                                          "value-format": "yyyy-MM-dd"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.changeDate(true)
                                          }
                                        },
                                        model: {
                                          value: _vm.endDate,
                                          callback: function($$v) {
                                            _vm.endDate = $$v
                                          },
                                          expression: "endDate"
                                        }
                                      }),
                                      _c(
                                        "el-checkbox",
                                        {
                                          staticStyle: {
                                            "padding-left": "2px"
                                          },
                                          on: { change: _vm.changeActive },
                                          model: {
                                            value: _vm.form.active,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "active", $$v)
                                            },
                                            expression: "form.active"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("FbaChannel.longTerm")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "auto-width",
                                      attrs: { "label-width": "0" }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "el-form-item__label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "FbaChannel.quotationLabel"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "bottom",
                                            width: "450",
                                            trigger: "hover"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "pop-content" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "标签用于客户查看当前方案时，向客户展示方案的特点，"
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "pop-content" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "包括时效保证、货损赔付保障、价格优势等。"
                                                )
                                              )
                                            ]
                                          ),
                                          _c("svg-icon", {
                                            staticStyle: {
                                              "font-size": "14px",
                                              "margin-top": "-3px"
                                            },
                                            attrs: {
                                              slot: "reference",
                                              "icon-class": "question"
                                            },
                                            slot: "reference"
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._l(_vm.form.labelList, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "span",
                                          {
                                            key: index,
                                            staticStyle: {
                                              "margin-left": "5px"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.editTag(item)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                style: {
                                                  backgroundColor:
                                                    item.backgroundColor,
                                                  color: item.textColor
                                                },
                                                attrs: {
                                                  closable: "",
                                                  size: "small"
                                                },
                                                on: {
                                                  close: function($event) {
                                                    return _vm.handleTagClose(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(item.labelName))]
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      _c("img", {
                                        staticStyle: {
                                          "vertical-align": "sub",
                                          "margin-left": "8px",
                                          cursor: "pointer"
                                        },
                                        attrs: {
                                          src: require("@/assets/add.png"),
                                          title: "添加标签",
                                          height: "16",
                                          width: "16"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onAddLabel()
                                          }
                                        }
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "FbaChannel.chargingMethod"
                                        )
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          no: "chargingMethod",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .local_cache_FbaJobConstants$CHARGING_METHODS,
                                          filterable: "",
                                          disabled: true,
                                          clearable: true,
                                          "default-value":
                                            _vm.form.chargingMethod + ""
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            _vm.form.chargingMethod = p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("FbaChannel.shippingType")
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          no: "shippingType",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .local_cache_FbaJobConstants$SHIPPING_TYPES,
                                          filterable: "",
                                          disabled: true,
                                          clearable: true,
                                          "default-value": _vm.form.shippingType
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            _vm.form.shippingType = p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "FbaChannel.destinationDistribution"
                                        )
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          no: "destinationDistribution",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES,
                                          filterable: "",
                                          disabled: true,
                                          clearable: true,
                                          "default-value":
                                            _vm.form.destinationDistribution +
                                            ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "FbaChannel.singleBoxLowestBillableWeight"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          disabled: true,
                                          value: _vm.form
                                            .singleBoxLowestBillableWeight
                                            ? _vm.form
                                                .singleBoxLowestBillableWeight
                                            : 0,
                                          no: "singleBoxLowestBillableWeight",
                                          "controls-position": "right",
                                          max: 999.99,
                                          min: 0,
                                          precision: 2
                                        }
                                      }),
                                      _vm._v(" " + _vm._s("KG") + " ")
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "FbaChannel.multipleBoxesCalculationRules"
                                        )
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          no: "multipleBoxesCalculationRules",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .local_cache_FbaJobConstants$MULTIPLE_BOXES_CALCULATION_RULES,
                                          filterable: "",
                                          disabled: true,
                                          clearable: true,
                                          "default-value":
                                            _vm.form
                                              .multipleBoxesCalculationRules
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            _vm.form.multipleBoxesCalculationRules =
                                              p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "FbaChannel.settlementWeightRoundingRules"
                                        )
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          no: "settlementWeightRoundingRules",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .local_cache_FbaJobConstants$SETTLEMENT_WEIGHT_ROUNDING_RULES,
                                          filterable: "",
                                          disabled: true,
                                          clearable: true,
                                          "default-value":
                                            _vm.form
                                              .settlementWeightRoundingRules
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            _vm.form.settlementWeightRoundingRules =
                                              p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "FbaChannel.bubbleCountingRatio"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          value: _vm.form.bubbleCountingRatio
                                            ? _vm.form.bubbleCountingRatio
                                            : 1,
                                          no: "bubbleCountingRatio",
                                          disabled: true,
                                          "controls-position": "right",
                                          max: 9999,
                                          min: 1,
                                          precision: 0
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "FbaChannel.BubbleSplittingRatio"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          value: _vm.form.bubbleSplittingRatio
                                            ? _vm.form.bubbleSplittingRatio
                                            : 0,
                                          no: "bubbleSplittingRatio",
                                          disabled: true,
                                          "controls-position": "right",
                                          max: 100,
                                          min: 0,
                                          precision: 0
                                        }
                                      }),
                                      _vm._v(" " + _vm._s("%") + " ")
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "FbaChannel.acceptableGoods"
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          attrs: { disabled: true },
                                          model: {
                                            value: _vm.acceptableGoods,
                                            callback: function($$v) {
                                              _vm.acceptableGoods = $$v
                                            },
                                            expression: "acceptableGoods"
                                          }
                                        },
                                        _vm._l(_vm.fbaCargoType, function(
                                          item
                                        ) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: item.code,
                                              attrs: { label: item.code }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.chineseName) +
                                                  " "
                                              )
                                            ]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c("el-form-item", {
                                    attrs: {
                                      label: _vm.$t("SeaExport.Considerations")
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 10 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { "label-width": "0" } },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "textarea",
                                          placeholder:
                                            "请输入下单的注意事项，如货物要求、包装要求、特殊要求、温馨提示、赔付承诺、免责说明等",
                                          rows: 10,
                                          maxlength: "10000",
                                          "show-word-limit": ""
                                        },
                                        model: {
                                          value: _vm.form.note,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "note", $$v)
                                          },
                                          expression: "form.note"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.showNextOne && !_vm.form.uuid,
                                  expression: "!showNextOne && !form.uuid"
                                }
                              ],
                              staticStyle: { "padding-top": "8px" },
                              attrs: { gutter: 10 }
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.onNextStepOne }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("Pricing.Next")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.showNextOne
                        ? _c(
                            "span",
                            [
                              _c(
                                "el-collapse-item",
                                { attrs: { title: "分区梯度", name: 2 } },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 10 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c("span", { staticClass: "title" }, [
                                            _vm._v(_vm._s("分区设置"))
                                          ]),
                                          _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                placement: "bottom",
                                                width: "450",
                                                trigger: "hover"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "pop-content" },
                                                [
                                                  _vm._v(
                                                    _vm._s("tips：什么是分区？")
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "pop-content" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      "如果几个目的地的运费价格是一样的，则可以组成一个分区；运费价格不相同的，则需要在不同的分区中。"
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("svg-icon", {
                                                staticStyle: {
                                                  "font-size": "14px",
                                                  "margin-top": "-3px"
                                                },
                                                attrs: {
                                                  slot: "reference",
                                                  "icon-class": "question"
                                                },
                                                slot: "reference"
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("el-col", { attrs: { span: 12 } }, [
                                        _c("span", { staticClass: "title" }, [
                                          _vm._v(_vm._s("阶梯设置"))
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 10 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 24 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "auto-width",
                                              attrs: { "label-width": "0" }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "blue" },
                                                [_vm._v(_vm._s("计费区间类型"))]
                                              ),
                                              _c(
                                                "el-popover",
                                                {
                                                  attrs: {
                                                    placement: "bottom",
                                                    width: "450",
                                                    trigger: "hover"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "pop-content"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          this.$t(
                                                            "FbaQuotation.chargePartTypeTipsL1"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "pop-content"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          this.$t(
                                                            "FbaQuotation.chargePartTypeTipsL2"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "pop-content"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          this.$t(
                                                            "FbaQuotation.chargePartTypeTipsL3"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c("svg-icon", {
                                                    staticStyle: {
                                                      "font-size": "14px",
                                                      "margin-top": "-3px"
                                                    },
                                                    attrs: {
                                                      slot: "reference",
                                                      "icon-class": "question"
                                                    },
                                                    slot: "reference"
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-radio-group",
                                                {
                                                  attrs: {
                                                    disabled: !!_vm.form
                                                      .serviceChannel
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.chargePartType,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "chargePartType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.chargePartType"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: 0 } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          this.$t(
                                                            "FbaQuotation.chargePartTypeKG"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: 1 } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          this.$t(
                                                            "FbaQuotation.chargePartTypeCBM"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticStyle: { "padding-bottom": "8px" },
                                      attrs: { gutter: 10 }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: {
                                                click: _vm.addPartitionSetting
                                              }
                                            },
                                            [_vm._v(_vm._s("添加"))]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "danger" },
                                              on: {
                                                click:
                                                  _vm.deletePartitionSetting
                                              }
                                            },
                                            [_vm._v(_vm._s("删除"))]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-left": "10px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "注意：分区最多添加50个，最少留1个"
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: { click: _vm.addSetupSetting }
                                            },
                                            [_vm._v(_vm._s("添加"))]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "danger" },
                                              on: {
                                                click: _vm.deleteSetupSetting
                                              }
                                            },
                                            [_vm._v(_vm._s("删除"))]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 10 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c("cargo-ag-grid", {
                                            staticStyle: { height: "200px" },
                                            attrs: {
                                              "config-module": "1001102",
                                              "grid-options":
                                                _vm.fqsz.gridOptions,
                                              "column-defs": _vm.fqszColumns,
                                              "row-data":
                                                _vm.fqsz.rowData || [],
                                              "show-side-bar": false
                                            },
                                            on: {
                                              gridReady: function(params) {
                                                _vm.fqsz.gridApi = params.api
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c("cargo-ag-grid", {
                                            staticStyle: { height: "200px" },
                                            attrs: {
                                              "config-module": "1001103",
                                              "grid-options":
                                                _vm.jtsz.gridOptions,
                                              "column-defs": _vm.jtszColumns,
                                              "row-data":
                                                _vm.jtsz.rowData || [],
                                              "show-side-bar": false
                                            },
                                            on: {
                                              gridReady: function(params) {
                                                _vm.jtsz.gridApi = params.api
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.showNextOne &&
                                  !_vm.showNextTwo &&
                                  !_vm.form.uuid
                                    ? _c(
                                        "el-row",
                                        {
                                          staticStyle: { "padding-top": "8px" },
                                          attrs: { gutter: 10 }
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "primary" },
                                                  on: {
                                                    click: _vm.onNextStepTwo
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("Pricing.Next")
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showNextTwo
                        ? _c(
                            "span",
                            [
                              _c(
                                "el-collapse-item",
                                { attrs: { title: "客户价", name: 3 } },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 10 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 20 } },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: {
                                                click: _vm.addCustomerPrice
                                              }
                                            },
                                            [_vm._v(_vm._s("添加"))]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "danger" },
                                              on: {
                                                click: _vm.deleteCustomerPrice
                                              }
                                            },
                                            [_vm._v(_vm._s("删除"))]
                                          ),
                                          _c(
                                            "el-popover",
                                            {
                                              staticStyle: {
                                                "padding-left": "10px"
                                              },
                                              attrs: {
                                                placement: "bottom",
                                                width: "450",
                                                trigger: "hover"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "pop-content" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      "公开报价对应的就是无需客户登录时，查询的那个价格。那边取的就是这个值。"
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "pop-content" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      "如果一个渠道有个公开报价，同时也有对特定客户的客户报价。当特定客户查询时，显示的就是客户报价。非特定客户查询的就是公开报价。"
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("svg-icon", {
                                                staticStyle: {
                                                  "font-size": "14px",
                                                  "margin-top": "-3px"
                                                },
                                                attrs: {
                                                  slot: "reference",
                                                  "icon-class": "question"
                                                },
                                                slot: "reference"
                                              })
                                            ],
                                            1
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s("注意：客户价不能重复添加")
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 4 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "blue",
                                                  attrs: { slot: "label" },
                                                  slot: "label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "FinanceManage.charge_currency"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("cargo-advance-select", {
                                                attrs: {
                                                  filterable: "",
                                                  clearable: false,
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .basic_data_Currency,
                                                  "default-value":
                                                    _vm.form.currency,
                                                  disabled: !_vm.isEdit
                                                },
                                                on: {
                                                  parentCallBack: function(
                                                    item
                                                  ) {
                                                    return (_vm.form.currency =
                                                      item.value)
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 10 } },
                                    [
                                      _c("el-col", { attrs: { span: 6 } }, [
                                        _c("span", { staticClass: "title" }, [
                                          _vm._v(_vm._s("运价级别"))
                                        ])
                                      ]),
                                      _c("el-col", { attrs: { span: 6 } }, [
                                        _c("span", { staticClass: "title" }, [
                                          _vm._v(_vm._s("分区信息"))
                                        ])
                                      ]),
                                      _c("el-col", { attrs: { span: 12 } }, [
                                        _c("span", { staticClass: "title" }, [
                                          _vm._v(_vm._s("阶梯信息"))
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 10 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("cargo-ag-grid", {
                                            staticStyle: { height: "200px" },
                                            attrs: {
                                              "config-module": "1001104",
                                              "grid-options":
                                                _vm.khjBjdx.gridOptions,
                                              "column-defs": _vm.khjBjdxColumns,
                                              "row-data":
                                                _vm.khjBjdx.rowData || [],
                                              "show-side-bar": false
                                            },
                                            on: {
                                              gridReady: function(params) {
                                                _vm.khjBjdx.gridApi = params.api
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("cargo-ag-grid", {
                                            staticStyle: { height: "200px" },
                                            attrs: {
                                              "config-module": "5",
                                              "grid-options":
                                                _vm.khjFq.gridOptions,
                                              "column-defs": _vm.khjFqColumns,
                                              "row-data": _vm.khjBjdxSelected
                                                ? _vm.khjBjdxSelected.fqRowData
                                                : [],
                                              "show-side-bar": false
                                            },
                                            on: {
                                              gridReady: function(params) {
                                                _vm.khjFq.gridApi = params.api
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c("cargo-ag-grid", {
                                            staticStyle: { height: "200px" },
                                            attrs: {
                                              "config-module": "6",
                                              "grid-options":
                                                _vm.khjJt.gridOptions,
                                              "column-defs": _vm.khjJtColumns,
                                              "row-data": _vm.khjBjdxFqSelected
                                                ? _vm.khjBjdxFqSelected
                                                    .tdRowData
                                                : [],
                                              "show-side-bar": false
                                            },
                                            on: {
                                              gridReady: function(params) {
                                                _vm.khjJt.gridApi = params.api
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.showNextTwo &&
                                  !_vm.showNextThree &&
                                  !_vm.form.uuid
                                    ? _c(
                                        "el-row",
                                        {
                                          staticStyle: { "padding-top": "8px" },
                                          attrs: { gutter: 10 }
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "primary" },
                                                  on: {
                                                    click: _vm.onNextStepThree
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("Pricing.Next")
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showNextThree
                        ? _c(
                            "span",
                            [
                              _c(
                                "el-collapse-item",
                                { attrs: { title: "附加费", name: 4 } },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 10 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 24 } },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: { click: _vm.addCharge }
                                            },
                                            [_vm._v(_vm._s("添加"))]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: { click: _vm.editCharge }
                                            },
                                            [_vm._v(_vm._s("编辑"))]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "danger" },
                                              on: { click: _vm.deleteCharge }
                                            },
                                            [_vm._v(_vm._s("删除"))]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-left": "8px"
                                              }
                                            },
                                            [_vm._v("注意：双击查看附加费详情")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 10 } },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticStyle: { "margin-top": "10px" },
                                          attrs: { span: 24 }
                                        },
                                        [
                                          _c("cargo-ag-grid", {
                                            staticStyle: { height: "200px" },
                                            attrs: {
                                              "config-module": "1001107",
                                              "grid-options":
                                                _vm.fjf.gridOptions,
                                              "column-defs": _vm.fjfColumns,
                                              "row-data": _vm.fjf.rowData || [],
                                              "show-side-bar": false
                                            },
                                            on: {
                                              gridReady: function(params) {
                                                _vm.fjf.gridApi = params.api
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ],
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.addCustomerPriceDialog.visible,
            title: "运价级别对应所属客户",
            width: "1000px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.addCustomerPriceDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "flex-grow": "1",
                display: "flex",
                "flex-direction": "column",
                "text-align": "center"
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-position": "left", "label-width": "90px" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.CustomerName") }
                            },
                            [
                              _c("cargo-company-select", {
                                attrs: {
                                  "method-params": {
                                    customer: true,
                                    active: true,
                                    fba: true
                                  },
                                  "check-credit": true,
                                  "static-options": _vm.customerCmpList,
                                  "default-value":
                                    _vm.addCustomerPriceDialog.accountId || "",
                                  "data-filter-function": _vm.customerIdFilter
                                },
                                on: {
                                  change: function(p) {
                                    _vm.addCustomerPriceDialog.accountId =
                                      p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 3 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.searchCustomerPriceHandler }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("cargo-ag-grid", {
            staticStyle: { "margin-top": "10px", height: "400px" },
            attrs: {
              "config-module": "1001108",
              "grid-options": _vm.addCustomerPriceDialog.gridOptions,
              "column-defs": _vm.addCustomerPriceDialog.columnDefs,
              "row-data": _vm.addCustomerPriceDialog.rowData,
              "grid-params": _vm.addCustomerPriceDialog.gridParams,
              "check-main-record": false,
              "deselect-main-record": false
            },
            on: {
              "update:gridParams": function($event) {
                return _vm.$set(
                  _vm.addCustomerPriceDialog,
                  "gridParams",
                  $event
                )
              },
              "update:grid-params": function($event) {
                return _vm.$set(
                  _vm.addCustomerPriceDialog,
                  "gridParams",
                  $event
                )
              },
              gridReady: function(params) {
                return (_vm.addCustomerPriceDialog.gridApi = params.api)
              }
            }
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.addCustomerPriceDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.podDialog.visible,
            title: "目的地维护",
            width: "1000px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.podDialog, "visible", $event)
            }
          }
        },
        [
          _c("div", { staticClass: "grid-view" }, [
            _c(
              "div",
              { staticClass: "main-content" },
              [
                _c("search-item", {
                  attrs: {
                    "config-module": "10020",
                    "custom-search-items": _vm.customSearchItems,
                    reset: true,
                    "expand-adv": true,
                    "custom-sim-query-placeholder": _vm.$t(
                      "common.tips.overseaWarehouseFuzzySearch"
                    )
                  },
                  on: {
                    "click-more": function(value) {
                      return (_vm.isAdvancedQuery = value)
                    },
                    advSearchItemCallBack: _vm.fetchData,
                    simSearchItemCallBack: _vm.fetchDataByKeyWord
                  }
                }),
                _c("cargo-ag-grid", {
                  staticStyle: { "margin-top": "10px", height: "400px" },
                  attrs: {
                    "config-module": "1001109",
                    "grid-options": _vm.podDialog.gridOptions,
                    "column-defs": _vm.podDialog.columnDefs,
                    "row-data": _vm.podDialog.rowData,
                    "grid-params": _vm.podDialog.gridParams,
                    "check-main-record": false,
                    "deselect-main-record": false
                  },
                  on: {
                    "update:gridParams": function($event) {
                      return _vm.$set(_vm.podDialog, "gridParams", $event)
                    },
                    "update:grid-params": function($event) {
                      return _vm.$set(_vm.podDialog, "gridParams", $event)
                    },
                    gridReady: function(params) {
                      return (_vm.podDialog.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmPod } },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.podDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.chargeDialog.visible,
            title: "附加费维护",
            "show-close": false,
            width: "1000px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.chargeDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "main-content",
              staticStyle: {
                "flex-grow": "1",
                display: "flex",
                "flex-direction": "column",
                width: "100%",
                height: "520px",
                "overflow-y": "auto"
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "left",
                    "label-width": "90px",
                    inline: true,
                    disabled: _vm.chargeDialog.action === "look"
                  }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s("基础信息"))
                        ])
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [_vm._v(_vm._s("附加费名称"))]
                              ),
                              _c("cargo-advance-select", {
                                staticStyle: { width: "180px" },
                                attrs: {
                                  "need-copy": false,
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_ChargeItem,
                                  "static-options": _vm.chargeItemList,
                                  "default-value":
                                    _vm.chargeDialog.charge.chargeItemId || "",
                                  "options-width": "100px"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.chargeDialog.charge.chargeItemId =
                                      p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [_vm._v(_vm._s("附加费类型"))]
                              ),
                              _c("cargo-advance-select", {
                                staticStyle: { width: "180px" },
                                attrs: {
                                  "need-copy": false,
                                  cache: false,
                                  clearable: false,
                                  "tag-name": _vm.isZh
                                    ? "chineseName"
                                    : "englishName",
                                  "tag-value": "code",
                                  "static-options":
                                    _vm.FbaJobConstants.SURCHARGE_TYPES,
                                  "default-value":
                                    _vm.chargeDialog.charge.chargeType
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.chargeDialog.charge.chargeType = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [_vm._v(_vm._s("币别"))]
                              ),
                              _c("cargo-advance-select", {
                                staticStyle: { width: "180px" },
                                attrs: {
                                  "need-copy": false,
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Currency,
                                  "default-value":
                                    _vm.chargeDialog.charge.currency || "",
                                  "options-width": "100px"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.chargeDialog.charge.currency = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      staticStyle: { "padding-top": "8px" },
                      attrs: { gutter: 10 }
                    },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s("加收场景"))
                        ])
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        "padding-top": "8px",
                        "padding-bottom": "8px"
                      },
                      attrs: { gutter: 10 }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.addChargeScene }
                            },
                            [_vm._v("增加加收场景")]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "padding-left": "10px" } },
                            [
                              _vm._v(
                                _vm._s(
                                  "注意：最多支持10个场景，如果第一个场景的加收条件达成，将按第一个场景的计费方式收费，不再执行下一个场景"
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._l(_vm.chargeDialog.charge.chargeSceneList, function(
                    item,
                    index
                  ) {
                    return _c(
                      "div",
                      {
                        key: item.uuid + index,
                        staticClass: "section",
                        staticStyle: { "padding-left": "20px" }
                      },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 20 } },
                              [
                                _c("el-form-item", {
                                  attrs: { label: "加收条件" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "danger" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteChargeScene(item)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "20px",
                              "padding-top": "8px"
                            }
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [_c("span", [_vm._v(_vm._s(" "))])]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            "need-copy": false,
                                            placeholder: "比较值类型",
                                            cache: false,
                                            clearable: "",
                                            "tag-name": _vm.isZh
                                              ? "chineseName"
                                              : "englishName",
                                            "tag-value": "code",
                                            "static-options":
                                              _vm.FbaJobConstants
                                                .COMPARISON_TYPES,
                                            "default-value": item.type1 || ""
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              item.type1 = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            "need-copy": false,
                                            placeholder: "比较规则",
                                            cache: false,
                                            clearable: "",
                                            "tag-name": _vm.isZh
                                              ? "chineseName"
                                              : "englishName",
                                            "tag-value": "code",
                                            "static-options":
                                              _vm.FbaJobConstants
                                                .COMPARISON_RULES,
                                            "default-value": item.rule1 || ""
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              item.rule1 = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            precision: 4,
                                            controls: false,
                                            placeholder: "值",
                                            max: 999999.9999
                                          },
                                          model: {
                                            value: item.value1,
                                            callback: function($$v) {
                                              _vm.$set(item, "value1", $$v)
                                            },
                                            expression: "item.value1"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            "need-copy": false,
                                            placeholder: " ",
                                            cache: false,
                                            clearable: "",
                                            "tag-name": _vm.isZh
                                              ? "chineseName"
                                              : "englishName",
                                            "tag-value": "code",
                                            "static-options":
                                              _vm.FbaJobConstants.AND_OR,
                                            "default-value":
                                              item.relationShip2 || ""
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              item.relationShip2 = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            "need-copy": false,
                                            placeholder: "比较值类型",
                                            cache: false,
                                            clearable: "",
                                            "tag-name": _vm.isZh
                                              ? "chineseName"
                                              : "englishName",
                                            "tag-value": "code",
                                            "static-options":
                                              _vm.FbaJobConstants
                                                .COMPARISON_TYPES,
                                            "default-value": item.type2 || ""
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              item.type2 = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            "need-copy": false,
                                            placeholder: "比较规则",
                                            cache: false,
                                            clearable: "",
                                            "tag-name": _vm.isZh
                                              ? "chineseName"
                                              : "englishName",
                                            "tag-value": "code",
                                            "static-options":
                                              _vm.FbaJobConstants
                                                .COMPARISON_RULES,
                                            "default-value": item.rule2 || ""
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              item.rule2 = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            precision: 4,
                                            controls: false,
                                            placeholder: "值",
                                            max: 999999.9999
                                          },
                                          model: {
                                            value: item.value2,
                                            callback: function($$v) {
                                              _vm.$set(item, "value2", $$v)
                                            },
                                            expression: "item.value2"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            "need-copy": false,
                                            placeholder: " ",
                                            cache: false,
                                            clearable: "",
                                            "tag-name": _vm.isZh
                                              ? "chineseName"
                                              : "englishName",
                                            "tag-value": "code",
                                            "static-options":
                                              _vm.FbaJobConstants.AND_OR,
                                            "default-value":
                                              item.relationShip3 || ""
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              item.relationShip3 = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            "need-copy": false,
                                            placeholder: "比较值类型",
                                            cache: false,
                                            clearable: "",
                                            "tag-name": _vm.isZh
                                              ? "chineseName"
                                              : "englishName",
                                            "tag-value": "code",
                                            "static-options":
                                              _vm.FbaJobConstants
                                                .COMPARISON_TYPES,
                                            "default-value": item.type3 || ""
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              item.type3 = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "180px" },
                                          attrs: {
                                            "need-copy": false,
                                            placeholder: "比较规则",
                                            cache: false,
                                            clearable: "",
                                            "tag-name": _vm.isZh
                                              ? "chineseName"
                                              : "englishName",
                                            "tag-value": "code",
                                            "static-options":
                                              _vm.FbaJobConstants
                                                .COMPARISON_RULES,
                                            "default-value": item.rule3 || ""
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              item.rule3 = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            precision: 4,
                                            controls: false,
                                            placeholder: "值",
                                            max: 999999.9999
                                          },
                                          model: {
                                            value: item.value3,
                                            callback: function($$v) {
                                              _vm.$set(item, "value3", $$v)
                                            },
                                            expression: "item.value3"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "计算方式" } },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: item.calcMethod,
                                          callback: function($$v) {
                                            _vm.$set(item, "calcMethod", $$v)
                                          },
                                          expression: "item.calcMethod"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: false } },
                                          [_vm._v(_vm._s("固定费用"))]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: true } },
                                          [_vm._v(_vm._s("计算公式"))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "20px",
                              "padding-top": "8px"
                            }
                          },
                          [
                            !item.calcMethod
                              ? _c(
                                  "el-row",
                                  { attrs: { gutter: 10 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 8 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { "label-width": "" } },
                                          [
                                            _c("el-input-number", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                precision: 2,
                                                controls: false,
                                                max: 999999.99
                                              },
                                              model: {
                                                value: item.fixedExpenses,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "fixedExpenses",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.fixedExpenses"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.calcMethod
                              ? _c(
                                  "el-row",
                                  { attrs: { gutter: 10 } },
                                  [
                                    _c("el-col", { attrs: { span: 24 } }, [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "1",
                                            "padding-bottom": "8px"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                width: "200px",
                                                "padding-right": "8px"
                                              },
                                              attrs: {
                                                "allow-create": true,
                                                placeholder:
                                                  "请输入数值或者选择参数",
                                                filterable: "",
                                                clearable: true
                                              },
                                              on: {
                                                change: function(p) {
                                                  _vm.chargeSceneParamLimit(
                                                    item,
                                                    p,
                                                    "param1"
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.param1,
                                                callback: function($$v) {
                                                  _vm.$set(item, "param1", $$v)
                                                },
                                                expression: "item.param1"
                                              }
                                            },
                                            _vm._l(
                                              _vm.FbaJobConstants
                                                .COMPARISON_TYPES,
                                              function(item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: _vm.isZh
                                                      ? item.chineseName
                                                      : item.englishName,
                                                    value: item.code
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _c("cargo-advance-select", {
                                            staticStyle: {
                                              width: "100px",
                                              "padding-right": "8px"
                                            },
                                            attrs: {
                                              "need-copy": false,
                                              "allow-create": true,
                                              filterable: "",
                                              placeholder: " ",
                                              cache: false,
                                              clearable: "",
                                              "tag-name": _vm.isZh
                                                ? "chineseName"
                                                : "englishName",
                                              "tag-value": "code",
                                              "static-options":
                                                _vm.FbaJobConstants.CALC_MODES,
                                              "default-value": item.mode2 || ""
                                            },
                                            on: {
                                              parentCallBack: function(p) {
                                                item.mode2 = p.value
                                              }
                                            }
                                          }),
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                width: "200px",
                                                "padding-right": "8px"
                                              },
                                              attrs: {
                                                "allow-create": true,
                                                placeholder:
                                                  "请输入数值或者选择参数",
                                                filterable: "",
                                                clearable: true
                                              },
                                              on: {
                                                change: function(p) {
                                                  _vm.chargeSceneParamLimit(
                                                    item,
                                                    p,
                                                    "param2"
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.param2,
                                                callback: function($$v) {
                                                  _vm.$set(item, "param2", $$v)
                                                },
                                                expression: "item.param2"
                                              }
                                            },
                                            _vm._l(
                                              _vm.FbaJobConstants
                                                .COMPARISON_TYPES,
                                              function(item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: _vm.isZh
                                                      ? item.chineseName
                                                      : item.englishName,
                                                    value: item.code
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _c("cargo-advance-select", {
                                            staticStyle: {
                                              width: "100px",
                                              "padding-right": "8px"
                                            },
                                            attrs: {
                                              "need-copy": false,
                                              placeholder: " ",
                                              cache: false,
                                              clearable: "",
                                              "tag-name": _vm.isZh
                                                ? "chineseName"
                                                : "englishName",
                                              "tag-value": "code",
                                              "static-options":
                                                _vm.FbaJobConstants.CALC_MODES,
                                              "default-value": item.mode3 || ""
                                            },
                                            on: {
                                              parentCallBack: function(p) {
                                                item.mode3 = p.value
                                              }
                                            }
                                          }),
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                width: "200px",
                                                "padding-right": "8px"
                                              },
                                              attrs: {
                                                "allow-create": true,
                                                placeholder:
                                                  "请输入数值或者选择参数",
                                                filterable: "",
                                                clearable: true
                                              },
                                              on: {
                                                change: function(p) {
                                                  _vm.chargeSceneParamLimit(
                                                    item,
                                                    p,
                                                    "param3"
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.param3,
                                                callback: function($$v) {
                                                  _vm.$set(item, "param3", $$v)
                                                },
                                                expression: "item.param3"
                                              }
                                            },
                                            _vm._l(
                                              _vm.FbaJobConstants
                                                .COMPARISON_TYPES,
                                              function(item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: _vm.isZh
                                                      ? item.chineseName
                                                      : item.englishName,
                                                    value: item.code
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-row",
                    {
                      staticStyle: { "padding-top": "16px", flex: "1" },
                      attrs: { gutter: 10 }
                    },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s("费用描述"))
                        ])
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "930px" },
                                attrs: {
                                  type: "textarea",
                                  rows: 5,
                                  maxlength: "200",
                                  "show-word-limit": ""
                                },
                                model: {
                                  value: _vm.chargeDialog.charge.remark,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.chargeDialog.charge,
                                      "remark",
                                      $$v
                                    )
                                  },
                                  expression: "chargeDialog.charge.remark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.chargeDialog.action === "look",
                    type: "primary"
                  },
                  on: { click: _vm.confirmCharge }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.chargeDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.label.visible,
            title: "标签维护",
            width: "340px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.label, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                "label-width": "85px",
                "label-position": "right",
                disabled: !_vm.isEdit
              }
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "span",
                    {
                      staticClass: "blue",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s("标签名称"))]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { maxlength: 10, no: "labelName" },
                    model: {
                      value: _vm.label.quotationLabel.labelName,
                      callback: function($$v) {
                        _vm.$set(_vm.label.quotationLabel, "labelName", $$v)
                      },
                      expression: "label.quotationLabel.labelName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "quotationLabel" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "blue",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s("背景颜色"))]
                  ),
                  _c("el-color-picker", {
                    staticStyle: { width: "220px" },
                    attrs: { no: "backgroundColor" },
                    model: {
                      value: _vm.label.quotationLabel.backgroundColor,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.label.quotationLabel,
                          "backgroundColor",
                          $$v
                        )
                      },
                      expression: "label.quotationLabel.backgroundColor"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "quotationLabel" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "blue",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s("文字颜色"))]
                  ),
                  _c("el-color-picker", {
                    staticStyle: { width: "220px" },
                    attrs: { no: "textColor" },
                    model: {
                      value: _vm.label.quotationLabel.textColor,
                      callback: function($$v) {
                        _vm.$set(_vm.label.quotationLabel, "textColor", $$v)
                      },
                      expression: "label.quotationLabel.textColor"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标签预览" } },
                [
                  _vm.label.quotationLabel.labelName
                    ? _c(
                        "el-tag",
                        {
                          style: {
                            backgroundColor:
                              _vm.label.quotationLabel.backgroundColor,
                            color: _vm.label.quotationLabel.textColor
                          }
                        },
                        [_vm._v(_vm._s(_vm.label.quotationLabel.labelName))]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.isEdit },
                  on: { click: _vm.toLabel }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.label.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }